import { generatedApi } from '@shared/api/generated-api';
import type { RootState } from '@shared/redux';

export const agentTestEndpoints = {
  getMessageListAgentTestListGet: {
    providesTags: ['agent_test'],
  },

  getUserAgentFieldsAgentTestFieldsValuesGet: {
    providesTags: [],
  },

  sendAgentMessageAgentTestMessagePost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      try {
        const { data } = await queryFulfilled;
        if (!data?.id) return;

        const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'getMessageListAgentTestListGet',
        );

        cachedArgs.forEach((args) => {
          if (args.agentId !== arg.agentId) return;
          if ((args.offset ?? 0) > 0) return;

          dispatch(
            generatedApi.util.updateQueryData('getMessageListAgentTestListGet', args, (draft) => {
              const items = draft.items ?? [];
              const exists = items.some((item) => item.id === data.id);
              if (exists) return;

              draft.items = [...items, data];
              if (typeof draft.count === 'number') {
                draft.count += 1;
              } else {
                draft.count = draft.items.length;
              }
            }),
          );
        });
      } catch {}
    },
  },

  clearHistoryAgentTestClearHistoryPost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      try {
        await queryFulfilled;

        const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'getMessageListAgentTestListGet',
        );

        cachedArgs.forEach((args) => {
          if (args.agentId !== arg.agentId) return;

          dispatch(
            generatedApi.util.updateQueryData('getMessageListAgentTestListGet', args, (draft) => {
              draft.items = [];
              draft.count = 0;
            }),
          );
        });

        const cachedFieldArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'getUserAgentFieldsAgentTestFieldsValuesGet',
        );

        cachedFieldArgs.forEach((args) => {
          if (args.agentId !== arg.agentId) return;

          dispatch(
            generatedApi.endpoints.getUserAgentFieldsAgentTestFieldsValuesGet.initiate(args, {
              forceRefetch: true,
              subscribe: false,
            }),
          );
        });
      } catch {}
    },
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
